import type { WatermarkPosition } from "./operations";

/** Centre and tiled start diagonal, corners straight; an angle the person chose themselves is not overwritten. */
export function angleAfterPositionChange(current: number, position: WatermarkPosition): number {
  if (current !== 0 && current !== 45) return current;
  return position === "center" || position === "tiled" ? 45 : 0;
}
